import ravenMiddleware from 'redux-raven-middleware';
import { sentryPublicDsn, version, environment } from 'config';

export default () => {
  return ravenMiddleware(sentryPublicDsn, {
    release: version,
    tags: {
      environment,
      model: 'client'
    },
    whitelistUrls: [
      /seekcdn\.com/
    ]
  });
};



/** WEBPACK FOOTER **
 ** ./app/store/middleware/createErrorLoggingMiddleware.js
 **/